import { useEffect } from 'react'
import { useShortcutsStore } from '../store/shortcuts'
import { formatKeyCombo, matchesKeyEvent } from '../lib/shortcuts'

/** Formatted label like "⌘B" or "Ctrl+B" */
export function useShortcutLabel(actionId: string): string {
  const combo = useShortcutsStore((s) => s.resolved[actionId])
  return combo ? formatKeyCombo(combo) : ''
}

/** Raw combo string for programmatic use */
export function useShortcutKey(actionId: string): string {
  return useShortcutsStore((s) => s.resolved[actionId] ?? '')
}

/** Register a global keydown handler for a shortcut action */
export function useGlobalShortcut(
  actionId: string,
  handler: () => void,
  enabled = true,
): void {
  const combo = useShortcutsStore((s) => s.resolved[actionId])

  useEffect(() => {
    if (!enabled || !combo) return

    const onKeyDown = (e: KeyboardEvent) => {
      if (matchesKeyEvent(combo, e)) {
        e.preventDefault()
        handler()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [combo, handler, enabled])
}
